export default function Rounding(num){
    const int = parseInt(num)
    if ((num - int) > 0.5){ 
        return int + 1
    }else if ((num - int) < 0.5 && (num-int)>0.01){
        return int + 0.5
    }else {
        return num
    }
}